import { Box, MediaBox, Typography } from "@jewlr/storybook/core"
import { FocusScope } from "@react-aria/focus"
import PropTypes from "prop-types"
import { connect } from "react-redux"

import { updateChoice } from "areas/product/store/actions"
import { to_currency } from "helpers/number"
import { filterProductOptions } from "helpers/product/product-filtering"
import { useNavigation } from "helpers/use-navigation"

import {
  ChoiceOption,
  OptionsSlider,
  OptionsSelect,
  OptionTitle,
} from "../components"

/**
 * Choice text option
 * example product - JWL0450-NUMBER
 */

const ChoiceOptions = ({
  selectedValues,
  setChoice,
  data,
  pref,
  options,
  filters,
}) => {
  const keyboardProps = useNavigation({ direction: "horizontal" })

  return (
    <OptionsSlider
      aria-label={`${data.heading.title} Options`}
      data-slider="true"
      role="radiogroup"
    >
      {filterProductOptions(options[pref], filters, true)
        .filter((ov) => ov.value != "")
        .map((ov) => {
          const selected = selectedValues[pref] == ov.value
          return (
            <ChoiceOption
              aria-selected={selected}
              data-cy={`product-wizard-option-${data.pref}-${ov.value}-mobile`}
              height="75px"
              key={`ctextopt-${ov.value}`}
              onClick={() => setChoice(pref, ov)}
              role="radio"
              selected={selected}
              tabIndex={selected ? 0 : -1}
              {...keyboardProps}
            >
              <Box fontSize="16px" lineHeight="75px">
                {ov.value}
              </Box>
              <OptionTitle>
                {ov.price > 0 ? " (+" + to_currency(ov.price) + ")" : ""}
              </OptionTitle>
            </ChoiceOption>
          )
        })}
    </OptionsSlider>
  )
}

ChoiceOptions.propTypes = {
  data: PropTypes.object,
  filters: PropTypes.object,
  options: PropTypes.object,
  pref: PropTypes.string,
  selectedValues: PropTypes.object,
  setChoice: PropTypes.func,
}

const InternalTextOptions = ({
  data,
  filters,
  options,
  selectedValues,
  setChoice,
  setSelectChoice,
}) => {
  return (
    <Box mb={2}>
      {Object.keys(options).map((pref) => (
        <div key={`ctext-${pref}`}>
          {/* Desktop select */}
          <MediaBox greaterThanOrEqual="tablet">
            <Typography bold color="black" fontSize="14px" letterSpacing="0">
              {data.options_display_labels
                ? data.options_display_labels[pref]
                : data.title}
              :
            </Typography>
            <OptionsSelect
              data-cy={`product-wizard-${data.pref}-selector`}
              onChange={(e) => setSelectChoice(pref, e, filters)}
              value={selectedValues[pref]}
            >
              {filterProductOptions(options[pref], filters, true).map((ov) => (
                <option key={`filterProduct-${ov.value}`} value={ov.value}>
                  {ov.display_name}
                  {ov.price > 0 ? " (+" + to_currency(ov.price) + ")" : ""}
                </option>
              ))}
            </OptionsSelect>
          </MediaBox>

          {/* Mobile */}
          <MediaBox lessThan="tablet">
            {Object.keys(options).length > 1 && (
              <Typography bold color="black">
                {data.title}
              </Typography>
            )}
            <FocusScope>
              <ChoiceOptions
                data={data}
                filters={filters}
                options={options}
                pref={pref}
                selectedValues={selectedValues}
                setChoice={setChoice}
              />
            </FocusScope>
          </MediaBox>
        </div>
      ))}
    </Box>
  )
}

InternalTextOptions.propTypes = {
  data: PropTypes.object,
  filters: PropTypes.object,
  options: PropTypes.object,
  selectedValues: PropTypes.object,
  setChoice: PropTypes.func,
  setSelectChoice: PropTypes.func,
}

const mapStateToProps = (state) => {
  return {
    filters: state.choices,
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    setChoice: (pref, data) => {
      dispatch(updateChoice(pref, data, true))
    },
    setSelectChoice: (pref, e, filters) => {
      const val = e.target.value
      const formattedOptions = filterProductOptions(
        ownProps.data.options,
        filters,
        true
      )
      const cv = formattedOptions.find(
        (cv) => cv.value == val && cv.pref == pref
      )
      dispatch(updateChoice(pref, cv, true))
    },
  }
}

const TextOptions = connect(
  mapStateToProps,
  mapDispatchToProps
)(InternalTextOptions)

export default TextOptions
